"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarBadgeMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
/** @class AvatarBadgeMixin */
/** @method */
var AvatarBadgeMixin = function AvatarBadgeMixin(props) {
  var size = props.size;
  return (0, _styledToken.default)({
    badgeSize: "AvatarBadge.badgeSizes." + size,
    backgroundColor: 'AvatarBadge.backgroundColor',
    borderRadius: 'AvatarBadge.borderRadius',
    borderColor: 'AvatarBadge.borderColor',
    borderWidth: 'AvatarBadge.borderWidth',
    color: 'AvatarBadge.foregroundColor',
    iconSize: "AvatarBadge.iconSizes." + size
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      badgeSize = _ref.badgeSize,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      color = _ref.color,
      iconSize = _ref.iconSize;
    return (0, _styledComponents.css)(["height:", "px;width:", "px;box-sizing:border-box;background-color:", ";border-radius:", ";border:", " solid ", ";color:", ";display:flex;justify-content:center;align-items:center;", "{height:", "px;width:", "px;}"], badgeSize, badgeSize, backgroundColor, borderRadius, borderWidth ? borderWidth + "px" : '2px', borderColor, color, _Icon.StyledIcon, iconSize, iconSize);
  })(props);
};
exports.AvatarBadgeMixin = AvatarBadgeMixin;